// Import model
import { DataviewCeramicTileCatalogItemResponse } from '../models/DataviewCeramicTileCatalogItemResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CeramicTileCatalogItem } from '../models/CeramicTileCatalogItem';
import { DataView } from '../models/DataView';
import { FilterCeramicTileCatalogItemRequest } from '../models/FilterCeramicTileCatalogItemRequest';

// Import dependency serializers (for complex types)
import { CeramicTileCatalogItemSerializer } from './CeramicTileCatalogItemSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterCeramicTileCatalogItemRequestSerializer } from './FilterCeramicTileCatalogItemRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewCeramicTileCatalogItemResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewCeramicTileCatalogItemResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewCeramicTileCatalogItemResponse instance
   */
  static deserialize(json: string): DataviewCeramicTileCatalogItemResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewCeramicTileCatalogItemResponse instance
   */
  static fromObject(obj: any): DataviewCeramicTileCatalogItemResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewCeramicTileCatalogItemResponse');
    }


    const instance: DataviewCeramicTileCatalogItemResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        CeramicTileCatalogItemSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterCeramicTileCatalogItemRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewCeramicTileCatalogItemResponse instances
   */
  static deserializeArray(json: string): DataviewCeramicTileCatalogItemResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewCeramicTileCatalogItemResponse instance to a JSON string
   */
  static serialize(instance: DataviewCeramicTileCatalogItemResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewCeramicTileCatalogItemResponse instance to a plain object
   */
  static toObject(instance: DataviewCeramicTileCatalogItemResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        CeramicTileCatalogItemSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterCeramicTileCatalogItemRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewCeramicTileCatalogItemResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewCeramicTileCatalogItemResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
